import { Indonesian } from 'flatpickr/dist/l10n/id'
import MonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { today } from '@/store/helpers'

export const fieldListData = [
  {
    key: 'name',
    label: 'Nama Partner',
    class: 'text-start font-[600]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-top font-[400]',
  },
  {
    key: 'phone',
    label: 'Nomor Telepon',
    class: 'text-start font-[600]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-center text-[#34A770] font-[400]',
  },
  {
    key: 'products',
    label: 'Produk',
    class: 'text-center font-[500]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-center font-[400]',
  },
  {
    key: 'register_date',
    label: 'Tanggal Pendaftaran',
    class: 'text-start font-[600]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-center font-[400]',
  },
  {
    key: 'amount',
    label: 'Saldo Minus',
    class: 'text-start font-[600]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-center font-[400]',
  },
  {
    key: 'id',
    label: '',
    class: 'text-center font-[500]',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
    },
    tdClass: 'align-center text-[#08A0F7]',
  },
]

export const configFlatPickr = {
  mode: 'single',
  locale: Indonesian,
  altInput: true,
  altFormat: 'j/n/Y',
  dateFormat: 'Y-m-d',
  maxDate: today,
  disableMobile: true,
  plugins: [
    new MonthSelect({
      shorthand: true,
      dateFormat: 'Y-m-d',
      altFormat: 'M Y',
    }),
  ],
}
